import React from "react";

const PinMain = () => {
  return (
    <svg fill="none" viewBox="0 0 35 35">
      <path fill="#072929" fill-rule="evenodd" d="m28.1085 17.6731-.0136.0687-.0091.0695c-.5537 4.2053-3.691 8.0581-7.0766 11.0159-1.6497 1.4413-3.2673 2.5912-4.4742 3.3809-.3507.2295-.6652.4275-.9339.5925-.1786-.1096-.3774-.2339-.5936-.3723-1.01-.6463-2.3882-1.5934-3.8547-2.7907-2.98883-2.4402-6.09958-5.7235-7.44133-9.4271l-.01663-.0459-.01868-.0451c-.63624-1.5372-.98878-3.2265-.98878-5.0045 0-7.16638 5.74644-12.97587 12.83502-12.97587 7.0886 0 12.8351 5.80949 12.8351 12.97587 0 .8776-.0859 1.7328-.249 2.5581Z" clip-rule="evenodd"/>
      <path fill="#fff" d="M21.2281 14.9742c0-3.1505-2.5539-5.70446-5.7044-5.70446-3.1505 0-5.70449 2.55396-5.70449 5.70446s2.55399 5.7045 5.70449 5.7045c3.1505 0 5.7044-2.554 5.7044-5.7045Z"/>
    </svg>
  )
}

export default PinMain